export default __webpack_public_path__ + "static/media/kid07.09cbfb7b.jpg";